export const ROUTES = {
  HOME: '',
  PAYMENT_TEST: 'payment/test',
  NEWS_AND_EVENTS: 'news_and_events',
  ANNOUNCEMENTS: 'announcements',
  ANNOUNCEMENT_DETAILS: 'announcement-details',
  VERIFICATIONS: 'verifications',
  AUTH: {
    REGISTER: 'auth/register',
    LOGIN: 'auth/login',
    FORGET_PASSWORD: 'auth/forget_password',
    RESET_PASSWORD: 'auth/reset_password',
  },
  DASHBOARD: 'dashboard',
  PROFILE: 'profile',
  ACADEMIC_PERSONNEL: 'academic-personnel',
  NOTIFICATIONS: 'notifications',
  ACCOUNT: 'account',
  SECURITY: 'security',
  USERS: 'users',
  ROLES: 'roles',
  AUDIT_LOGS: 'audit-logs',
  EVALUATION: 'evaluation',
  OCCUPATIONAL_ASSESSMENT: 'occupational-assessment',
};
